'use client'

import classNames from 'classnames'
import Link from 'next/link'

import { useI18n } from '@/shared/providers'

import type { Tag } from './config'
import { availableTags, isAll } from './config'
import styles from './view.module.css'

export function TagFilter(props: { selectedTag: Tag }) {
    return (
        <div className={styles.filtersContainer}>
            {availableTags.map((tag) => (
                <TagButton key={tag} tag={tag} selected={props.selectedTag === tag} />
            ))}
        </div>
    )
}

type TagButtonProps = {
    tag: Tag
    selected?: boolean
}

function TagButton({ tag, selected }: TagButtonProps) {
    const tagClassName = `tag-${tag}`
    const { i18n } = useI18n()

    return (
        <Link
            href={isAll(tag) || selected ? '/' : `/${tag}`}
            className={styles.filterButton}
            style={{ textDecoration: 'none' }}
            tabIndex={0}
            prefetch={false}
        >
            <p className={styles.filterParagraph}>
                <span className={classNames(styles.filterTitle, tagClassName, { 'filter-selected': selected })}>
                    {i18n[`TAG_${tag}`]}
                </span>
            </p>
        </Link>
    )
}
